/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilityteamdescription2Inputs */

const zh_share_visibilityteamdescription2 = /** @type {(inputs: Share_Visibilityteamdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队成员可访问`)
};

const en_share_visibilityteamdescription2 = /** @type {(inputs: Share_Visibilityteamdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members of your team can access`)
};

const es_share_visibilityteamdescription2 = /** @type {(inputs: Share_Visibilityteamdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los miembros de tu equipo pueden acceder`)
};

/**
* | output |
* | --- |
* | "Members of your team can access" |
*
* @param {Share_Visibilityteamdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilityteamdescription2 = /** @type {((inputs?: Share_Visibilityteamdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilityteamdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilityteamdescription2(inputs)
	if (locale === "en") return en_share_visibilityteamdescription2(inputs)
	return es_share_visibilityteamdescription2(inputs)
});
export { share_visibilityteamdescription2 as "share_visibilityTeamDescription" }